import { assign, createMachine } from 'xstate';
import { AuthService } from './authService.js';
class AuthContext {
    constructor() {
        this.authenticationResult = undefined;
        this.msalAccounts = [];
    }
}
// Consider unauthenticated assign on entry.  Initializing is only ever at start
export const createAuthMachine = () => createMachine({
    id: 'auth',
    initial: 'initializing',
    context: new AuthContext(),
    states: {
        initializing: {
            invoke: {
                id: 'detectAndHandleRedirect',
                src: () => () => { AuthService.detectAndHandleRedirect(); }
            },
            on: {
                NO_MSAL_ACCOUNTS_FOUND: {
                    target: 'unauthenticated',
                    actions: [
                        assign({
                            authenticationResult: context => undefined,
                            msalAccounts: context => [],
                        }),
                        (context, event) => {
                            // eslint-disable-next-line no-console
                            console.debug(`No Authenticated Accounts Found, resetting context`);
                        },
                    ],
                },
                LOCAL_MSAL_ACCOUNTS_FOUND: {
                    target: 'msalAuthenticatedMissingToken',
                    actions: [
                        assign({
                            msalAccounts: (context, { msalAccounts }) => msalAccounts,
                        }),
                        // (context, event) => {
                        //   console.log(JSON.stringify(event.msalAccounts));
                        // },
                    ],
                },
                SUCCESSFUL_MSAL_REDIRECT_WITH_TOKEN: {
                    target: 'msalAuthenticated',
                    actions: [
                        assign({
                            authenticationResult: (context, { authenticationResult }) => authenticationResult,
                        })
                    ],
                }
            }
        },
        msalAuthenticatedMissingToken: {
            invoke: {
                id: 'attemptSilentTokenRetrieval',
                src: (context) => () => { AuthService.attemptSilentTokenRetrieval(context.msalAccounts[0]); }
            },
            on: {
                MSAL_ACCESS_TOKEN_NOT_AVAILABLE: {
                    target: 'unauthenticated'
                },
                MSAL_ACCESS_TOKEN_FOUND: {
                    target: 'msalAuthenticated',
                    actions: [
                        assign({
                            authenticationResult: (context, { authenticationResult }) => authenticationResult,
                        })
                    ]
                }
            }
        },
        msalAuthenticated: {
            entry: [
                context => {
                    if (!context.authenticationResult) {
                        throw new Error();
                    }
                    AuthService.notifyAuthenticated(context.authenticationResult.accessToken);
                },
            ],
            invoke: {
                id: 'keepAlive',
                src: (context) => (authCallback) => {
                    setTimeout(() => {
                        authCallback('ATTEMPT_REFRESH');
                    }, 1000 * 1200);
                }
            },
            on: {
                ATTEMPT_REFRESH: {
                    actions: (context) => {
                        AuthService.attemptSilentTokenRetrieval(context.msalAccounts[0]);
                    }
                },
                MSAL_ACCESS_TOKEN_NOT_AVAILABLE: {
                    target: 'unauthenticated'
                },
                MSAL_ACCESS_TOKEN_FOUND: {
                    target: 'msalAuthenticated',
                    actions: [
                        assign({
                            authenticationResult: (context, { authenticationResult }) => authenticationResult,
                        })
                    ]
                }
            }
        },
        unauthenticated: {
            entry: [
                context => {
                    AuthService.notifyUnauthenticated();
                },
            ],
        }
    }
});
//# sourceMappingURL=authMachine.js.map